import { FC } from 'react'
import { LayoutFooterContainer, LayoutFooterLeftContent } from '../layout.styled'
import { ReactComponent as YunoLogoPoweredIcon } from '../../../assets/yuno-logo-powered.svg'
import { useTranslation } from 'react-i18next'

export const LayoutFooter: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutFooterContainer>
      <LayoutFooterLeftContent>
        <span>{t('Powered by')}</span>
        <YunoLogoPoweredIcon />
      </LayoutFooterLeftContent>
    </LayoutFooterContainer>
  )
}
